// sebelUserActions.js

import {
    GET_SEBEL_USERS,
    GET_SEBEL_USERS_SUCCESS,
    GET_SEBEL_USERS_FAIL,
    ADD_SEBEL_USER,
    ADD_SEBEL_USER_SUCCESS,
    ADD_SEBEL_USER_FAIL,
    UPDATE_SEBEL_USER,
    UPDATE_SEBEL_USER_SUCCESS,
    UPDATE_SEBEL_USER_FAIL,
    DELETE_SEBEL_USER,
    DELETE_SEBEL_USER_SUCCESS,
    DELETE_SEBEL_USER_FAIL,
    SET_SEBEL_USER_FIELD_ERRORS,
  } from './actionTypes'
  
  // Get Sebel Users
  export const getSebelUsers = () => ({
    type: GET_SEBEL_USERS,
  });
  
  export const getSebelUsersSuccess = (users) => ({
    type: GET_SEBEL_USERS_SUCCESS,
    payload: users,
  });
  
  export const getSebelUsersFail = (error) => ({
    type: GET_SEBEL_USERS_FAIL,
    payload: error,
  });
  
  // Add Sebel User
  export const addSebelUser = (user,onClose) => ({
    type: ADD_SEBEL_USER,
    payload: {user,onClose},
  });
  
  export const addSebelUserSuccess = (user) => ({
    type: ADD_SEBEL_USER_SUCCESS,
    payload: user,
  });
  
  export const addSebelUserFail = (error) => ({
    type: ADD_SEBEL_USER_FAIL,
    payload: error,
  });
  
  // Update Sebel User
  export const updateSebelUser = (user,onClose) => ({
    type: UPDATE_SEBEL_USER,
    payload: {user,onClose},
  });
  
  export const updateSebelUserSuccess = (user) => ({
    type: UPDATE_SEBEL_USER_SUCCESS,
    payload: user,
  });
  
  export const updateSebelUserFail = (error) => ({
    type: UPDATE_SEBEL_USER_FAIL,
    payload: error,
  });
  
  // Delete Sebel User
  export const deleteSebelUser = (id) => ({
    type: DELETE_SEBEL_USER,
    payload: id,
  });
  
  export const deleteSebelUserSuccess = (id) => ({
    type: DELETE_SEBEL_USER_SUCCESS,
    payload: id,
  });
  
  export const deleteSebelUserFail = (error) => ({
    type: DELETE_SEBEL_USER_FAIL,
    payload: error,
  });
  
  // Set Field Errors
  export const setSebelUserFieldErrors = (errors) => ({
    type: SET_SEBEL_USER_FIELD_ERRORS,
    payload: errors,
  });
  